import * as Sentry from '@sentry/vue'

export function sentrySetUser(user) {
  if (!user) {
    Sentry.setUser(null)
    return
  }

  Sentry.setUser({ username: user.username, email: user.email, id: user.id })
}
